import { render, staticRenderFns } from "./ResumeSolicitudeSupplier.vue?vue&type=template&id=7971d3c6&lang=pug"
import script from "./ResumeSolicitudeSupplier.vue?vue&type=script&lang=js"
export * from "./ResumeSolicitudeSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports